import img1 from '../assets/nosotros/about1.jpg';
import img2 from '../assets/nosotros/about2.jpg';
import img3 from '../assets/nosotros/about3.jpg';

const doctores = [
    { nombre: 'Dr. Jorge Chumbe Melo', cop: '6261' },
    { nombre: 'Dr. Walter A. Peña Gonzáles', cop: '11565' },
    { nombre: 'Dra.Paola Espinoza Roman', cop: '12611' },
    { nombre: 'Dra.Katherine Chumbe Llimpe', cop: '60377' },
    { nombre: 'Dr. Bruno Palacios Rios', cop: '5541' }
];

export const AboutFocus = [
    {
        id: '001',
        title: 'Sobre Nosotros',
        description: 'Nuestro objetivo es lograr la satisfacción total de nuestros pacientes, brindándoles tratamientos de la más alta calidad, en nuestras instalaciones encontrarán un ambiente agradable y cálido, además de una atención personalizada a cargo de profesionales especialistas en las diversas áreas de la odontología.',
        img: img1,
    },
    {
        id: '002',
        title: 'Quiénes somos',
        description: doctores,
        img: img2,
        isList: true,
    },
    {
        id: '003',
        title: 'Especialización',
        description: 'Contamos con tecnología de última generación y un equipo de especialistas altamente calificados, lo que nos permite realizar tratamientos como endodoncia, ortodoncia, rehabilitaciones completas y estética dental, asegurando siempre calidad, precisión y durabilidad en cada procedimiento.',
        img: img3,
    },
];
